var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChrp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#F24139",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 10.492a1.07 1.07 0 1 1-2.142 0a1.07 1.07 0 0 1 1.83-.76a1.07 1.07 0 0 1 .312.76m-.857-.206a.429.429 0 1 1-.857 0a.429.429 0 0 1 .857 0m.214.428a.214.214 0 1 0 0-.428a.214.214 0 0 0 0 .428"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.857 12.321c0 2.91-1.646 5.409-4.024 6.536c1.92-2.044 1.885-4.56 1.881-5.066v-.055a1.12 1.12 0 0 1-.784.407c-1.341 0-2.644-1.089-4.029-2.563c-1.38-1.466-2.044-3.073-2.044-3.613c0-.278.154-.463.257-.591l.065-.077c.06-.082.107-.146.107-.228c0-.21-.24-.21-.502-.21c-.947 0-2.143.468-3.115.952A6.73 6.73 0 0 1 12 5.143c3.789 0 6.857 3.214 6.857 7.178M6.103 15.986A7.1 7.1 0 0 0 7.804 18H9.4c1.778 0 3.458-1.17 3.458-3.043c0-1.869-1.68-3.377-3.458-3.377H5.177a7.6 7.6 0 0 0 .643 3.848h6.609c-.588.288-2.1.858-3.459.858c-.921 0-2.027-.15-2.867-.3M12 8.606c0-.712.861-.892 1.294-.892c2.906 0 2.992 2.893 2.992 3.326c0 .064-.005.129-.018.21l1.402.356c.368.094.45.523.137.715l-1.556.965l-.235-1.277c-.142.24-.343.42-.605.42c-.6 0-1.607-.755-2.117-1.209S12 9.497 12 8.606"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChrp);
export default __webpack_public_path__ + "static/media/chrp.472581b8c85f642cf4a6c8c4ed776965.svg";
export { ForwardRef as ReactComponent };